import React from "react";
import { protectedHttp } from "../../helpers/http.helper";
import { ReactComponent as PlusSvg } from "../../assets/svg/plus.svg";
import { useNavigate } from "react-router-dom";
import AgencyCard from "../../components/cards/AgencyCard";

const AllAgencies = () => {
  const [agencies, setAgencies] = React.useState([]);

  const navigate = useNavigate();

  const getAgencies = React.useCallback(async () => {
    try {
      const { data } = await protectedHttp.get("/admin/agency/all");
      setAgencies(data.agencies);
    } catch (error) {
      console.log(error);
    }
  }, []);

  React.useEffect(() => {
    getAgencies();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const deleteAgency = (id) => {
    if (window.confirm("Are you sure to delete?")) {
      protectedHttp
        .delete(`/admin/agency/${id}`)
        .then(() => {
          getAgencies();
        })
        .catch((err) => console.log(err.response.data.msg));
    }
  };

  return (
    <>
      <main>
        <div className="main-content">
          <div className="admin-top-bar-wrapper">
            <div className="admin-top-bar-container">
              <h1>All Agencies</h1>

              <button onClick={() => navigate("/admin/add-agency")}>
                <PlusSvg /> Create Agency
              </button>
            </div>
          </div>
          <div className="listing-table-wrapper">
            <div className="listing-table">
              <div className="listing-table-row listing-table-header">
                <div className="td-name">Name</div>
                <div className="td-email">Email</div>
                <div className="td-actions">Actions</div>
              </div>

              {agencies.map((agency) => (
                <AgencyCard
                  key={agency._id}
                  agency={agency}
                  deleteHandler={() => deleteAgency(agency._id)}
                />
              ))}
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default AllAgencies;
